import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import AppProvider from './hooks';
import ScrollToTop from './hooks/useScroll';
import Routes from './routes';
import { createInterceptors } from './services/createInterceptors';
import GlobalStyles from './styles/GlobalStyles';

const App: React.FC = () => (
  <AppProvider>
    <GlobalStyles />

    <BrowserRouter>
      <ScrollToTop />
      <Routes />
    </BrowserRouter>
  </AppProvider>
);
createInterceptors();

export default App;
